export type ListMarkerType = 'a' | 'A' | 'i' | '1'

// Tailwind's preflight resets list-style, which overrides the ol type attribute's markers.
export const LIST_STYLE_CLASS_BY_MARKER_TYPE: Record<ListMarkerType, string> = {
  a: 'list-[lower-alpha]',
  A: 'list-[upper-alpha]',
  i: 'list-[lower-roman]',
  '1': 'list-decimal'
}
